import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase } from 't4core';
import { Router, ActivatedRoute } from '@angular/router';
import { OneWayCountingResultInfo } from 't4core';
import * as moment from 'moment';

@Component({
  selector: 'CountingDetails',
  templateUrl: './CountingDetails.html',
})
export class CountingDetailsComponent extends PageBase implements OnInit {

  public countingId: String;

  constructor(el: ElementRef, private route: ActivatedRoute) {
        super(el, "OneWayAdmin");
  }

  async ngOnInit() {
    this.route.params.subscribe(async params => {
      if (params.Id) {
        this.countingId = params.Id;
      } else {

      }
    });
  }

  async approve(row: OneWayCountingResultInfo) {
    this.Api.post<boolean>("OneWay/ApproveCountingResult", null, { id: row.Id });
    row.HandledAt = moment();
    row.HandledBy = "tmp";
    row.IsHandled = true;
    this.UI.snackBar("Approved!");
  }

  async reject(row: OneWayCountingResultInfo) {
    this.Api.post<boolean>("OneWay/RejectCountingResult", null, { id: row.Id });
    row.HandledAt = moment();
    row.HandledBy = "tmp";
    row.IsHandled = true;
    this.UI.snackBar("Approved!");
  }
}
